<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()" max-width="688px">
    <v-card class="d-flex justify-content-center">
      <!-- <v-card-title>{{ dialogTitle }}</v-card-title> -->
      <v-card-text>
        <div class="text-center py-10">
          <v-img
            @click="closeDialog"
            class="cancel-image"
            src="../assets/icons/cancel.png"
            height="15px"
            width="15px"
          />
          <h3>{{ dialogTitle }}</h3>
        </div>
        <v-form class="ma-2 mt-3" ref="forgotPassword" lazy-validation>
          
          <v-text-field 
            :label="'lng_email_text' | translate"
            v-model="email" :rules="[rules.required, rules.email]"></v-text-field>
          
          <p class="warning-error mt-2" v-if="error">{{ error }}</p>
          <div class="date-header d-flex justify-content-center py-5 mt-3">
            <v-btn color="#0B7894" dark @click="validate" :loading="showLoading">{{ "lng_send_email_txt" | translate }}</v-btn>
          </div>
        </v-form>
      </v-card-text>
      <Alert
        v-if="alertToggle"
        :message-data="flashMessageData"
        :alert-toggle="alertToggle"
        @alertToggleUpdate="alertToggle = false"
      />
    </v-card>
  </v-dialog>
</template>
  
<script>
import UserService from "../services/user-service";
import router from "../router";
import { translateFunc } from '../common/Filters';
import Alert from "../components/Alert"

export default {
  name: "ForgotPasswordModal",
  components: {
    Alert
  },
  data() {
    return {
      dialog: false,
      email: "",
      rules: {
        required: value => !!value || translateFunc("lng_required_text"),
        email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || translateFunc("lng_required_validate_email");
        }
      },
      showLoading: false,
      error: "",
      alertToggle: false,
      flashMessageData: {},
    };
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    dialogTitle: {
      type: String,
      default: "Dialog"
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    },
  },
  mounted() {},
  methods: {
    validate() {
      const that = this;
      this.$nextTick(async function() {
        if (that.$refs.forgotPassword.validate()) {
          this.forgotPasswordRequest();
        }
      });
    },
    async forgotPasswordRequest() {
      this.error = "";
      this.showLoading = true;
      let response;
      try {
        response = await UserService.forgotPassword(this.email);
      } catch (e) {
        this.error = translateFunc("lng_try_again_txt");
        this.showLoading = false;
        this.showAlert({msg: translateFunc("lng_try_again_txt"), status: 1});
      }
      if (!response.status) {
        this.error = "";
        this.showLoading = false;
        this.$emit("updateLocalData");
        this.showAlert(response);
        setTimeout(() => {
          this.email = "";
          this.closeDialog();
        }, 1000);
      } else {
        this.showLoading = false;
        this.error = translateFunc("user_not_found_msg");
        response.msg =  this.error;
        this.showAlert(response);
      }
    },
    showAlert(res){
      this.flashMessageData = res;
      this.alertToggle = true;
    }
  }
};
</script>
<style scoped>
.theme--light.v-card > .v-card__text {
  color: #000;
  width: 90%;
}
.cancel-image {
  cursor: pointer;
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.v-dialog > .v-card {
  background-image: linear-gradient(to top, #8aa8ad, transparent);
}
</style>
  